// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { MAX_OFFERS } from '../RenewalOfferForm/helpers';
import messages from '../messages';
import OfferHeader from './OfferHeader';
import OfferTermsRow, { RenderTermLength } from './OfferTermsRow';
import OfferRentRow, { RenderTermCost } from './OfferRentRow';
import TransactionCodeRows from './TransactionCodeRows';

export { RenderTermLength, RenderTermCost };
export { default as RenderHeader } from './OfferHeader';

const PreviousOffersDetails = ({ offer }) => {
  const { renewalOfferLetterRows } = useFlags();
  const { offerDate, offerExpirationDate, leaseOfferTransactions } = offer;

  const termLengths = Array.from(
    { length: MAX_OFFERS },
    (_, i) => offer[`offer${i + 1}TermLength`],
  );
  const rents = Array.from(
    { length: MAX_OFFERS },
    (_, i) => offer[`offer${i + 1}Rent`],
  );
  const providerNames = Array.from(
    { length: MAX_OFFERS },
    (_, i) => offer[`offer${i + 1}ProviderName`],
  );

  return (
    <Box
      className="panel unit-information panel-withheader"
      data-test="previous-offer-details"
    >
      <OfferHeader
        offerDate={offerDate}
        offerExpirationDate={offerExpirationDate}
      />
      <Box sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
          <Box sx={{ width: '25%' }}>
            <Typography variant="titleSmall">
              <FormattedMessage {...messages.term} />
            </Typography>
          </Box>
          <OfferTermsRow termLengths={termLengths} />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
          <Box sx={{ width: '25%' }}>
            <Typography variant="titleSmall">
              <FormattedMessage {...messages.leaseRent} />
            </Typography>
          </Box>
          <OfferRentRow rents={rents} providerNames={providerNames} />
        </Stack>
        {renewalOfferLetterRows && (
          <TransactionCodeRows lotx={leaseOfferTransactions} />
        )}
      </Box>
    </Box>
  );
};

export default PreviousOffersDetails;
